// Màn placeholder của M0: caption + một hotspot mở cửa sổ. Chưa có gameplay.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { tabDef, type TabId } from '@data/screens';
import { askConfirm, closeWindows, openWindow } from '@state/modules/ui';
import { TextButton } from '../kit/TextButton';

export function ScreenPlaceholder({
  tab,
  screen,
  children,
}: {
  tab: TabId;
  screen: string;
  children?: JSX.Element;
}): JSX.Element {
  return (
    <>
      <div class="ht-caption" data-id="caption">
        <b data-id="screen-title">{t(`ui.screen.${tab}.${screen}`)}</b>
        <span>{t('ui.placeholder.caption')}</span>
      </div>
      <button
        type="button"
        class="ht-hotspot"
        data-id="hotspot-probe"
        style={{ left: '150px', top: '330px' }}
        onClick={() => openWindow({ kind: 'placeholder', screen: `${tab}.${screen}` })}
      >
        {t('ui.placeholder.hotspot')}
      </button>
      {children}
    </>
  );
}

export function PlaceholderWindow({ screen }: { screen: string }): JSX.Element {
  const [tab, id] = screen.split('.') as [TabId, string];
  const phase = tabDef(tab).screens.find((s) => s.id === id)?.phase ?? 'P0';
  return (
    <>
      <div class="ht-block" data-id="placeholder-body">
        {t('ui.placeholder.window.body')}
      </div>
      <div class="ht-actions">
        <span class="ht-chip">{t(`ui.screen.${screen}`)}</span>
        <span class="ht-chip">{t('ui.placeholder.window.phase', { phase })}</span>
      </div>
      <div class="ht-actions">
        <TextButton
          id="window-ask"
          onClick={() =>
            askConfirm({
              textKey: 'ui.placeholder.ask.text',
              confirmKey: 'ui.placeholder.ask.confirm',
              onConfirm: closeWindows,
            })
          }
        >
          {t('ui.placeholder.window.ask')}
        </TextButton>
      </div>
    </>
  );
}
